// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const thundurus_therian: PokeData = {
  "id": 10020,
  "name": "thundurus-therian",
  "height": 30,
  "weight": 610,
  "base_experience": 290,
  "types": [
    PokeType.ELECTRIC,
    PokeType.FLYING
  ],
  "api_moves": [
    "thrash",
    "leer",
    "bite",
    "thunder-shock",
    "thunder",
    "agility",
    "swagger",
    "rain-dance",
    "crunch",
    "uproar",
    "charge",
    "revenge",
    "astonish",
    "shock-wave",
    "hammer-arm",
    "heal-block",
    "dark-pulse",
    "nasty-plot",
    "discharge",
    "volt-switch",
    "wildbolt-storm"
  ],
  "moves": [
    "leer",
    "bite",
    "thunder-shock",
    "thunder",
    "rain-dance",
    "crunch",
    "dark-pulse",
    "volt-switch",
    "chatter",
    "zap-cannon",
    "thunder-punch",
    "quick-tempo",
    "air-slash"
  ],
  "evolution_chain": {
    "id": 329,
    "item": null,
    "species": [
      {
        "name": "thundurus",
        "order": 643,
        "types": [
          PokeType.ELECTRIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 95,
    "speed": 125,
    "ability_power": 180
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
